var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'corner-tag',
    { 'is-grid': _vm.isGridView }
  ]},[(_vm.tagImage)?_c('img',{attrs:{"src":_vm.tagImage}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }